import { useFormikContext } from "formik";
import { shouldRenderFieldHelper } from "./arrayGroupComponentHelper";

function useArrayGroupComponent() {
  const formik = useFormikContext();

  const shouldRenderField = (field, arrObjName) => {
    return shouldRenderFieldHelper(field, arrObjName, formik);
  };

  return { shouldRenderField };
}

export default useArrayGroupComponent;
